import React, {useState, useRef, useEffect, useContext} from 'react';
import Header from '../../components/header';
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {baseURL, host} from "../../services/api";
import AuthContext from '../../components/shared/AuthContext';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import OrgContext from "../../organisation/OrgContext";
import ImportItems from "../../components/ImportItems";
import template from "../../assets/templates/template_importer_des_articles_fr.csv";

import {DataGrid, GridToolbar} from '@mui/x-data-grid';

import jwtInterceoptor from '../../components/shared/jwtInterceptor';

import {Document, Page, Text, View, StyleSheet, Image} from '@react-pdf/renderer';
import { PDFDownloadLink } from '@react-pdf/renderer';
import moment from "moment";
import { frFR, enUS } from '@mui/x-data-grid';
import {LinearProgress} from "@mui/material";
import {etatStockColumns, exportStockState} from "../../helpers/ExportCsvHelper";
import {toast} from "react-toastify";
import useAuthHelper from "../../helpers/AuthHelper";



const Items = () => {
    const {onlyCommercial} = useAuthHelper();

    const [t, i18n] = useTranslation();
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [displayEdit, setDisplayEdit] = useState('none');
    const [productId, setProductId] = useState();
    const [exportCsv, setExportCsv] = useState(false);
    const ExpandedComponent = ({data}) => <pre>{JSON.stringify(data, null, 2)}</pre>;
    const {organisation, changeOrg} = useContext(OrgContext);
    const requiredCsvFileHeaders = [
        'type',
        'nom',
        'Prix de vente',
        'Description sur les information de vente',
        'Prix de revient',
        'Description sur les information de d\'achat',
        'Quantité\r'
    ];
    console.log(organisation)
    const [loadingData, setLoadingData] = useState(false);
    const deleteItem = async (pr) => {
        Swal.fire({
            title: t('Are you sure?'),
            text: t("You won't be able to revert this!"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('Yes, delete it!'),
            cancelButtonText: t("Cancel")
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    console.log('Attempting to delete product with ID:', pr.id);
                    const response = await axios.delete(baseURL +`/product/delete/${pr.id}`);
    
                    if (response.status === 200 && response.data.status === true) {
                        getProducts();
                        Swal.fire({
                            icon: 'success',
                            title: t('Deleted!'),
                            text: t('The product has been deleted.'),
                        });
                    } else {
                        console.log("The delete is not done: " + JSON.stringify(response.data));
                        Swal.fire({
                            icon: 'error',
                            title: t('Failed!'),
                            text: response.data.message || t('Something went wrong, try again.'),
                        });
                    }
                } catch (error) {
                    console.error('Error during deletion:', error);
                    Swal.fire({
                        icon: 'error',
                        title: t('Error!'),
                        text: t('An error occurred while trying to delete the product. Please try again.'),
                    });
                }
            }
        });
    };
    
    

    const columns = [
        { field: 'name', headerName: t("le nom d’article"), flex: 1, },
        { field: 'type', headerName: t("Type"), flex: 1, },
        { field: 'sellingPrice', headerName: `${t("Prix de vente")} (${organisation?.currency?.code})`, flex: 1,
            valueGetter: (params) =>
                params.row.type === 'Services' ? "Remplissable lors de a création d'une facture" : Number(params.row.sellingPrice).toFixed(2)
        },
        { field: 'costPrice', headerName: `${t("Prix de revient")} (${organisation?.currency?.code}))`, flex: 1,
            valueGetter: (params) =>
                params.row.type === 'Services' ? "Remplissable lors de a création d'une facture" : Number(params.row.valeurStock).toFixed(2)
        },
        { field: 'qty', headerName: t("Quantité"), flex: 1, },
        { field: 'valeur', headerName:` ${t('valeur')} (${organisation?.currency?.code}))`, flex: 1,
        valueGetter: (params) =>
            params.row.type === 'Services' ? "Remplissable lors de a création d'une facture" :Number( params.row.valeurStock*params.row.qty).toFixed(2)
    },
        {
            field: 'actions',
            headerName: t("ACTIONS"),
            width: 180,
            sortable: false,
            disableClickEventBubbling: true,
            
            renderCell: (params) => {
                const onDelete = (e) => {
                  const currentRow = params.row;
                  return deleteItem(currentRow);
                };

                const onEdit = (e) => {
                    const currentRow = params.row;

                    navigate("/items/edit/"+currentRow?.id);
                  };

                const onDetails = (e) => {
                    const currentRow = params.row;

                    navigate("/items/details/"+currentRow?.id);
                  };
                
                return (
                    <div className="btn-list">
                        <button onClick={onDetails} id="bDel" type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-eye" title={'Voir les détails'}> </span>
                        </button>
                        <button onClick={onEdit} id="bDel" type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-edit" title={'Modifier'}> </span>
                        </button>
                        <button onClick={onDelete} id="bDel" type="button" className="btn  btn-sm btn-danger">
                            <span className="fe fe-trash-2" title={'Supprimer'}> </span>
                        </button>
                    </div>
                );
            },
        }
    ];

    const [products, setProducts] = useState([]);
    const {user, logout} = useContext(AuthContext);
    const getProducts = async () => {
        console.log("getProducts");
        setLoading(true);
        setLoadingData(true);
        await axios.get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
            .then((response) => {
                console.log("response.data.data ", response.data.data);
                setProducts(response.data.data)
                console.log("setProducts");

                setLoading(false);
                setLoadingData(false);
            })
            .catch((error) => {
                setLoadingData(false);
                console.log("error while retrieving products by user" + error)
            })
    }
    const handleSelectRow = ({selectedRows}) => {
        if (selectedRows.length === 0) {
            setDisplayEdit('none');
        } else {
            setDisplayEdit('block');
            setProductId(selectedRows[0].id);
            console.log('Selected Rows: ', selectedRows);
        }
    };
    const deleteProduct = async (productId) => {
        const response = await axios.delete(baseURL + `/product/delete/${productId}`)
            .then((response) => {
                getProducts();
                setLoading(false)
                Swal.fire(
                    t('Le produit est supprimer avec succès'),
                    t(''),
                    'success'
                );
            })
            .catch((error) => console.log("error while retrieving products by user" + error))
    };
    useEffect(() => {
        onlyCommercial();

        getProducts();
        console.log("products ", products);
    }, [])
    const navigate = useNavigate();

    // Prepar data to export

    const [selectedArticles, setSelectedArticles] = useState([]);
    const [proccesing, setProccessing] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [allArticlesSelected, setAllArticlesSelected] = useState([]);

    const [msgErrorDate, setMsgErrorDate] = useState("");
    const exportAllArticlesQty = async () => {
        setMsgErrorDate("");
        var from_date = document.getElementById("date-from");
        var to_date = document.getElementById("date-to");
        if(from_date && to_date){
            if(from_date.value && to_date.value){
                let date1 = new Date(`${from_date.value}T00:00:00.000000Z`);
                let date2 = new Date(`${to_date.value}T23:59:59.000000Z`);
                console.log(from_date.value, to_date.value);
                if (date1 > date2) {
                    setMsgErrorDate(t("la date de fin doit être supérieure ou égal à la date de début"));
                } else  {
                    if (exportCsv) {
                        let allArticles = products.filter(
                            (p) => selectedArticles.includes(p.id) == true
                                && (new Date(p.created_at) >= date1 && new Date(p.created_at) <= date2)
                        );
                        console.log('allArticels jjj',allArticles)
                        let header = "état de stock entre le " + from_date.value + " et le " + to_date.value;
                        if (exportStockState(etatStockColumns, allArticles, header)) {
                            toast.success('Exportation Csv générer avec succéess', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });
                        } else {
                            toast.error('Une erreur s\'est produite lors de l\'exportation du fichier CSV', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: false,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });
                        }
                        console.log("allArticles : ", allArticles);
                        setExportCsv(false);
                    }else{
                        window.$('#modalDateExportArticles').modal('hide');
                        setProccessing(true);
                        setLoaded(false);
                        window.$('#modalExportArticles').modal('show');
                        let allArticles = products.filter(
                            (p) => selectedArticles.includes(p.id) == true
                                && (new Date(p.created_at) >= date1 && new Date(p.created_at) <= date2)
                        );
                        setProccessing(false);
                        setLoaded(true);
                        setAllArticlesSelected(allArticles);
                        console.log("dlsqkm",allArticlesSelected)
                    }

                }
            }else{
                setMsgErrorDate(t("Remplissez tous les champs"));
            }
        }

    }

    const modalDateExportAllArticlesQty = async () => {
        window.$('#modalDateExportArticles').modal('show');
    }


    const styles = StyleSheet.create({
        page: {
            // flexDirection: 'row',
            // backgroundColor: '#E4E4E4'
        },
        section: {
            margin: 10,
            padding: 10,
            fontSize: 11,
            //flex: 1,
            // flexGrow: 1,

        },
        header: {
            flexDirection: "row",
            marginBottom: 12,
            borderWidth: 1
        },
        cell: {
            borderRightWidth: 1,
            justifyContent: "center",
            alignItems: "center",
            minHeight: 25
        },
        cellRow: {
            minHeight: 25,
            padding: 5,
            paddingTop: 7
        },
        textHeader: {
            fontSize: 10,
            fontWeight: "bold",
            textAlign: "center"
        },
        row: {
            flexDirection: "row",
        },
        textRow: {
            fontSize: 9.5
        },
        headerPage: {
            flexDirection: "row",
            padding: 5,
            borderWidth: 1.5,
            marginBottom: 5
        },
        leftSide: {
            flex: 1,
            justifyContent: "space-between"
        },
        centerContainer: {
            flex: 2,
            justifyContent: "space-between",
            alignItems: "center"
        },
        rightSide: {
            flex: 1,
            justifyContent: "flex-end",
            paddingLeft: 40
        }
    });

    const ExportAllArticles = ({data=[]}) => {
        let date_now = new Date();
        let copyIcon = ' © ';

        let total = 0;
        let totalV =0;

        return(
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                        <View style={styles.headerPage}>
                            <View style={styles.leftSide}>
                                <Text>{organisation?.name}</Text>
                                <Text>Impression provisoire</Text>
                            </View>
                            <View style={styles.centerContainer}>
                                <Text style={{textAlign: "center", fontSize: 18, fontWeight: "bold", marginBottom: 6}}>L'état de stock</Text>
                                <View style={{flexDirection: "row"}}>
                                    <Text style={{fontSize: 11.5}}>Articles</Text>
                                </View>
                            </View>
                            <View style={styles.rightSide}>
                                <View style={{flexDirection: "row", justifyContent: "flex-start"}}>
                                    <Text style={{textAlign: "left", marginRight: 4}}></Text>
                                    <Text style={{textAlign: "left"}}></Text>
                                </View>
                                <View style={{
                                    justifyContent: "center",
                                    alignItems: "flex-end"
                                }}
                                >
                                </View>
                            </View>
                        </View>
                        <View style={[styles.headerPage, {border: 0, padding: 0}]}>
                            <View style={styles.leftSide}>
                                <Text style={{fontSize: 9}}>{copyIcon}<Text style={{htmlContnet: '\\00A9'}}></Text>{"ELMANAGER COMMERCIALISATION ET COMPTABILITE"}</Text>
                            </View>
                            <View style={[{justifyContent: "flex-end"}]}>
                                <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                                    <Text style={{textAlign: "right", marginRight: 4}}>Date de tirage : </Text>
                                    <Text style={{textAlign: "right"}}>{date_now?.getDate()}/{date_now?.getMonth()+1}/{date_now?.getFullYear()} à {date_now?.getUTCHours()+1}:{date_now?.getMinutes() < 10 ? "0"+date_now?.getMinutes() : date_now?.getMinutes()}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.header}>
                            <View style={[styles.cell, {flex: 2}]}><Text style={styles.textHeader}>Date Mise à jour</Text></View>
                            <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Nom article</Text></View>
                            <View style={[styles.cell, {flex: 3}]}><Text style={styles.textHeader}>Nom dépot</Text></View>
                            <View style={[styles.cell, {flex: 3, borderRightWidth: 1}]}><Text>Quantité</Text></View>
                            <View style={[styles.cell, {flex: 3, borderRightWidth: 0}]}><Text>Valeur</Text></View>
                        </View>
                        <View style={{border: 1,}}>
                        {
    data?.map((history) => {
        
        return history.depot.map((d) => {
            total += parseFloat(d.quantity);
            totalV += parseFloat((parseFloat(d.quantity) * history.valeurStock).toFixed(2));
            return (
            <View key={Math.random()} style={styles.row}>
                <View style={[styles.cellRow, {flex: 2}]}>
                    <Text style={styles.textRow}>
                        {moment(new Date(history.updated_at)).format("DD/MM/YYYY")}
                    </Text>
                </View>
                <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                    <Text style={[styles.textRow, { textAlign: "left" }]}>
                        {history?.name}
                    </Text>
                </View>
                <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                    <Text style={[styles.textRow, { textAlign: "left" }]}>
                        {d.depot?.name}
                    </Text>
                </View>
                <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                    <Text style={[styles.textRow, { textAlign: "right" }]}>
                        {d.quantity}
                    </Text>
                </View>
                <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                    <Text style={[styles.textRow, { textAlign: "right" }]}>
                        {Number(parseFloat(d.quantity) * history.valeurStock).toFixed(2)} {organisation.currency.symbol}
                    </Text>
                </View>
            </View>
        )});
    })
}

                            <View style={[styles.row, {borderTop: 1}]}>
                                <View style={[styles.cellRow, {flex: 5, paddingRight: 16}]}><Text style={[styles.textRow, { textAlign: "right" }]}>Totaux</Text></View>
                                <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                    <Text style={[styles.textRow, { textAlign: "right" }]}>{total.toFixed(2)}</Text>
                                </View>
                                <View style={[styles.cellRow, {flex: 3, borderLeftWidth: 1}]}>
                                    <Text style={[styles.textRow, { textAlign: "right" }]}>{totalV.toFixed(2)} {organisation.currency.symbol}</Text>
                                </View>
                            </View>
                        </View>



                    </View>
                </Page>
            </Document>
        )
    };


    return (
        <>
            {/*<Header/>*/}
            {/* Export account modal */}
            <div className="modal fade show" id="modalDateExportArticles" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered text-center " role="document">
                    <div className="modal-content tx-size-sm">
                        <div className="modal-body text-center p-4 pb-5">
                            <h4 className="text-default tx-semibold">{t("Selection l'intervalle de temps")}</h4>
                            <div class="form-group">
                                <label htmlFor="exampleInputEmail1" className="requiredElt">{t("De")} *</label>
                                <input type="date" className="form-control" id={"date-from"} name={"date-from"}/>
                            </div>
                            <div class="form-group">
                                <label htmlFor="exampleInputEmail1" className="requiredElt">{t("à")} *</label>
                                <input type="date" className="form-control" id={"date-to"} name={"date-to"}/>
                            </div>
                            {msgErrorDate && msgErrorDate.length > 0 ? (<div class="alert alert-danger" role="alert">
                                <p>{msgErrorDate}</p>
                            </div>): null}
                            <button
                                className='btn btn-success pd-x-25'
                                style={{height: 38}}
                                onClick={exportAllArticlesQty}
                            >{t("Exporter")}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade show" id="modalExportArticles" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered text-center " role="document">
                    <div className="modal-content tx-size-sm">
                        {proccesing ? (<div className="modal-body text-center p-4 pb-5">
                            <i className="icon icon-clock fs-70 text-warning lh-1 my-5 d-inline-block"></i>
                            <h4 className="text-warning tx-semibold">{t("Traitement en cours!")}</h4>
                            <p className="mg-b-20 mg-x-20">{t("Patientez s'il-vous-plait")}</p>
                        </div>) : null}
                        {loaded ? (<div className="modal-body text-center p-4 pb-5">
                            <i className="icon icon-check fs-70 text-success lh-1 my-5 d-inline-block"></i>
                            <h4 className="text-success tx-semibold">{t("Généré avec succès!")}</h4>

                            <PDFDownloadLink
                                document={<ExportAllArticles data={[...allArticlesSelected]}/>}
                                fileName="etat-stock.pdf"
                                className='btn btn-success pd-x-25'
                                style={{height: 38}}
                            >

                                {({blob, url, loading, error}) =>
                                    loading ? t("Loading document...") : t("Télécharger")
                                }
                            </PDFDownloadLink>
                        </div>) : null}
                    </div>
                </div>
            </div>

            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">{t('Liste des articles')}</h3>
                                <div className="actionCardContainer">
                                    <button type="button" onClick={() => navigate('/items/add')}
                                            className="floatRightBtn btn btn-icon  btn-primary me-2 bradius"><i
                                        className="fe fe-plus"></i></button>

                                    {/* <ImportItems
                                        template={template}
                                        requiredCsvHeaders={requiredCsvFileHeaders}
                                        apiSaveUrl={'/product/save'}
                                        id={'article'}
                                    /> */}
                                    <button style={{display: displayEdit}} type="button"
                                            onClick={() => navigate(`/items/edit/${productId}`)}
                                            className="floatRightBtn btn btn-icon  btn-primary me-2 bradius"><i
                                        className="fe fe-edit"></i></button>
                                    <button style={{display: displayEdit}} type="button"
                                            onClick={() => deleteProduct(productId)}
                                            className="floatRightBtn btn btn-icon  btn-primary me-2 bradius"><i
                                        className="fe fe-trash"></i></button>
                                    {selectedArticles && selectedArticles.length > 0 ? (
                                        <>
                                            <button type="button" onClick={modalDateExportAllArticlesQty}
                                                    className="floatRightBtn btn btn-icon  btn-info-light me-2 ">
                                                <i className="fe fe-download"></i> Exporter l'état de stock PDF
                                            </button>

                                            <button type="button" onClick={()=> {
                                                setExportCsv(true);
                                                modalDateExportAllArticlesQty();
                                            }}
                                                    className="floatRightBtn btn btn-icon  btn-info-light me-2 ">
                                                <i className="fe fe-download"></i> Exporter l'état de stock CSV
                                            </button>
                                        </>
                                        ) : null}
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="table-responsive">
                                    <div style={{height: 600, width: '100%'}}>
                                        <DataGrid
                                            rows={products}
                                            columns={columns}
                                            pagination={false}
                                            checkboxSelection
                                            localeText={
                                                i18n.language == "fr" ?
                                                    frFR.components.MuiDataGrid.defaultProps.localeText :
                                                    enUS.components.MuiDataGrid.defaultProps.localeText
                                            }
                                            onRowSelectionModelChange={(ids) => {
                                                setSelectedArticles(ids);
                                            }}
                                            slotProps={{
                                                toolbar: {
                                                    printOptions: {disableToolbarButton: true},
                                                    csvOptions: {disableToolbarButton: true},
                                                }
                                            }
                                            }
                                            slots={{
                                                toolbar: GridToolbar,
                                                loadingOverlay: LinearProgress,

                                            }}
                                            loading={loadingData}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Items;